import { app } from '../../../../../app';
import { Controller } from './account-custom-attributes.controller';

app.component('companyUserDirectoriesManageAccountCustomAttributes', {
    bindings: {
        accountId: '<',
        companyId: '<',
        profileAttributes: '<',
    },
    controller: Controller,
    templateUrl: require('./account-custom-attributes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/custom-attributes/account-custom-attributes.component.js